import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { GetAnimationClip, PlayAnimation } from '../AnimationHelper';
import Renderable from '../../../Component/Renderable';

export class ShowPlusFive extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta: {
            showAdButton: boolean;
            scale: [number, number];
        }
    ): IterableIterator<number> {
        const renderComponent: Renderable = gameObject.getComponent(Renderable);
        if (meta.showAdButton) {
        } else {
        }

        renderComponent.visible = false;
        yield* PlayAnimation(GetAnimationClip('UIPopIn', gameObject, { scale: meta.scale }));

        /*
        // Button slide down.
        renderComponent.visible = true;


        renderComponent.alpha = 0;
        const alphaTween = this.getTween(renderComponent);

        alphaTween.to({ alpha: 1 }, 50);

        yield* AwaitIterators([
            this.startTween(alphaTween),
        ]);
        */
    }
}
